import React, { memo } from "react";
import classnames from "classnames";
import { Element } from "src/components/base";

interface IProps {
    className?: string;
    children: React.ReactNode;
    breakpoint?: string;
}

function Container(props: IProps) {
    const { children, breakpoint, className } = props;
    return (
        <Element
            {...props}
            className={classnames("container", "relative mx-auto my-0 w-[1168px]", className, {
                [`is-${breakpoint}`]: breakpoint,
            })}
        >
            {children}
        </Element>
    );
}

export default memo(Container);
